/**
 * The report's four-step severity ramp, mapped to the DS tokens already in tailwind.config.js.
 *
 * Order is bucket order — none / one / two / three-or-more — so a bucket index indexes straight into
 * these arrays. Kept in one place because the same ramp drives the KPI cards, the column chart, every
 * stacked bar, the donut and all four legends.
 */

export const SEGMENT_FILL = ['bg-ds-green', 'bg-ds-blue', 'bg-ds-amber', 'bg-ds-rose'];

export const SEGMENT_ACCENT_BORDER = [
  'border-l-ds-green',
  'border-l-ds-blue',
  'border-l-ds-amber',
  'border-l-ds-rose',
];

/** Only the top bucket's figure is tinted; the rest stay ink so the page does not read as alarmist. */
export const SEGMENT_VALUE_TEXT = ['text-gray-900', 'text-gray-900', 'text-gray-900', 'text-ds-rose-dk'];

/** conic-gradient and inline bar fills need literal colours rather than classes. */
export const SEGMENT_HEX = ['#14866D', '#1D6FA4', '#D97706', '#E8432C'];

/** Men / women comparison bars: ink versus mid-gray, never two semantic colours. */
export const GENDER_FILL = { male: 'bg-gray-800', female: 'bg-gray-500' };
export const GENDER_VALUE_TEXT = { male: 'text-gray-900', female: 'text-gray-700' };

/** Co-occurrence: the leading pair is emphasised, the rest recede. */
export const PAIR_LEAD_FILL = 'bg-ds-blue';
export const PAIR_REST_FILL = 'bg-[#509DC0]';

/**
 * Benchmarks table grading, keyed by the backend's verdict — below the India Inc range / inside it /
 * above it. The backend computes the grade next to the rate so the colour and the number can never
 * disagree; this only maps the word to a token.
 */
/* The DEFAULT ramp tokens, not the -dk variants: ds-rose-dk (#C43320) and ds-amber-dk (#B45309) are
   both dark brick shades and read as the same colour at table size. These match SEGMENT_HEX, so the
   table's verdict colours are the same three the report's charts already use. */
export const GRADE_TEXT = {
  good: 'text-ds-green',
  watch: 'text-ds-amber',
  risk: 'text-ds-rose',
};

export const GRADE_DOT = {
  good: 'bg-ds-green',
  watch: 'bg-ds-amber',
  risk: 'bg-ds-rose',
};

export const TRACK = 'bg-gray-200';
